export default __webpack_public_path__ + "static/media/eviction.e15dc267.svg";